import { render, staticRenderFns } from "./reportResult.vue?vue&type=template&id=6ef00fd3&scoped=true&"
import script from "./reportResult.vue?vue&type=script&lang=js&"
export * from "./reportResult.vue?vue&type=script&lang=js&"
import style0 from "./reportResult.vue?vue&type=style&index=0&id=6ef00fd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef00fd3",
  null
  
)

export default component.exports